const REWARD = {
  SET_VALUE: "SET_VALUE",
  SET_OBJECT: "SET_OBJECT",
  SET_REFERENCE_DATA: "SET_REFERENCE_DATA",
  SET_LOAD: "SET_LOAD",
  ADD_PRODUCT: "ADD_PRODUCT",
  REMOVE_PRODUCT: "REMOVE_PRODUCT"
}

export default REWARD
